import AdminOnboarding from './admin';
import ClientOnboarding from './client';
import ContractorOnboarding from './contractor';
import WitnessOnboarding from './witness';

const tenants = {
    admin: AdminOnboarding,
    client: ClientOnboarding,
    contractor: ContractorOnboarding,
    i9: WitnessOnboarding
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/index.jsx